import {dashboardActionTypes} from "../constants/ActionTypes";

let temp = [];

try{
  temp = JSON.parse(localStorage.getItem("bookmarks"));
} catch (error) {}

const initialState = {
  list: temp,
  openDialog: false
};

const bookmark = (state = initialState, action) => {
  switch (action.type) {
    case dashboardActionTypes.ADD_BOOKMARK:
      return {
        ...state,
        list: [].concat(state.list, [action.data])
      };
      break;
    case dashboardActionTypes.DELETE_BOOKMARK:
      return {
        ...state,
        list: [
          ...state.list.slice(0, action.index),
          ...state.list.slice(action.index + 1)
        ]
      };
      break;
    case dashboardActionTypes.OPEN_DIALOG:
      return {
        ...state,
        openDialog: true
      };
      break;
    case dashboardActionTypes.CLOSE_DIALOG:
      return {
        ...state,
        openDialog: false
      };
      break;
    default:
      break;
  }

  return state;
};

export default bookmark;



// WEBPACK FOOTER //
// ./reducers/bookmark.reducers.js